export const messages = {
  en: {
    menuUserManage: {
      search: {
        title: 'Search Conditions',
        muId: 'Please enter ID',
        name: 'Please enter menu name',
        seq: 'Please enter sequence'
      },
      list: {
        title: 'Common Menu'
      },
      table: {
        muId: 'ID',
        name: 'Menu',
        icon: 'Icon',
        seq: 'Sequence'
      },
      add: {
        title: 'Add Menu',
        menu: 'Menu',
        menuPlaceholder: 'Required, please select menu',
        icon: 'Icon',
        seq: 'Sequence',
        seqPlaceholder: 'Required, please enter sequence',
        success: 'Add success',
        error: 'Add failed'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to delete this menu?',
        success: 'Delete success',
        error: 'Delete failed'
      },
      validate: {
        menuRequired: 'Menu is required',
        iconRequired: 'Icon is required',
        seqRequired: 'Sequence is required'
      },
      fetchError: 'Failed to fetch menu data'
    }
  },
  zh: {
    menuUserManage: {
      search: {
        title: '查询条件',
        muId: '请输入编号',
        name: '请输入菜单',
        seq: '请输入列顺序'
      },
      list: {
        title: '常用菜单'
      },
      table: {
        muId: '编号',
        name: '菜单',
        icon: '图标',
        seq: '顺序'
      },
      add: {
        title: '添加菜单',
        menu: '菜单',
        menuPlaceholder: '必填，请选择菜单',
        icon: '图标',
        seq: '列顺序',
        seqPlaceholder: '必填，请填写列顺序',
        success: '添加成功',
        error: '添加失败'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定删除常用菜单',
        success: '删除成功',
        error: '删除失败'
      },
      validate: {
        menuRequired: '菜单不能为空',
        iconRequired: '图标不能为空',
        seqRequired: '列顺序不能为空'
      },
      fetchError: '获取菜单数据失败'
    }
  }
}